var map = {
	"./control go backward.fbx": "1a08",
	"./control go forward.fbx": "efa9",
	"./control go left.fbx": "4607",
	"./control go right.fbx": "764c",
	"./control happy idle.fbx": "0b91",
	"./control jog backwards.fbx": "96ac",
	"./control natural idle.fbx": "824e",
	"./control run backwards.fbx": "38b3",
	"./control standing idle old.fbx": "c054",
	"./control standing idle old2.fbx": "fd47",
	"./control standing idle.fbx": "eb00",
	"./control stay idle.fbx": "07ad",
	"./control step backward fight.fbx": "0159",
	"./control turn left 90.fbx": "6cb9",
	"./control turn left a bit.fbx": "206b",
	"./control turn right 90.fbx": "3836",
	"./control turn right a bit.fbx": "8906",
	"./general walking.fbx": "9102"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5d7";